import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay", "title", "body", "copyBtn"];

  open(e) {
    const btn = e.currentTarget;
    this.titleTarget.textContent = btn.dataset.promptTitle;
    this.bodyTarget.textContent = btn.dataset.promptBody;
    this.overlayTarget.hidden = false;
    // [hidden] is display:none, which can't transition — remove it, then add
    // the open class next frame so the panel scale/opacity actually animates.
    requestAnimationFrame(() => this.overlayTarget.classList.add("telemetry__prompt-overlay--open"));
    document.body.style.overflow = "hidden";
    if (this.hasCopyBtnTarget) this.copyBtnTarget.textContent = "Copy";
  }

  close() {
    this.overlayTarget.classList.remove("telemetry__prompt-overlay--open");
    document.body.style.overflow = "";
    const duration = parseFloat(getComputedStyle(this.overlayTarget).transitionDuration) * 1000;
    if (duration > 0) {
      this.overlayTarget.addEventListener("transitionend", () => { this.overlayTarget.hidden = true; }, { once: true });
    } else {
      this.overlayTarget.hidden = true;
    }
  }

  backdropClick(e) {
    if (e.target === this.overlayTarget) this.close();
  }

  keydown(e) {
    if (e.key === "Escape") this.close();
  }

  copy() {
    const text = this.bodyTarget.textContent;
    navigator.clipboard.writeText(text).then(() => {
      this.copyBtnTarget.textContent = "Copied!";
      setTimeout(() => { this.copyBtnTarget.textContent = "Copy"; }, 2000);
    });
  }
}
